export default {"src":"/_next/static/image/public/images/ic_green_incomplete_circle.c5cc7aee88c0a18ab870e2d479c82202.svg","height":30,"width":30};